export class RatingsModel {

  modelId!: number;
  unitTypeId!: number;
  modelCode!: string;
  description!: string;
  airHandlerModel!: boolean;
  sureFlowModel!: boolean;
  locationId!: number;
  familyId!: number;
  productId!: string;
  imageFileName!: string;

}
